import requests from "./httpService";

const ExpensesServices = {

    getExpenses: async () =>{
        return requests.get(`/other-expenses`);
    },
   
    addExpenses : async (body) =>{
        return requests.post(`/other-expenses`,body);
    },

    deleteExpenses : async (id) =>{
        return requests.delete(`/other-expenses/${id}`);
    },
  
    updateExpenses : async (id,body) =>{
        return requests.patch(`other-expenses/${id}`,body);
    },
   
}
export default ExpensesServices;